import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles({ name: 'CardSectionHeader' })(() => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    minHeight: '40px',
  },
}));

export default useStyles;
